<template>
  <div class="home">
    <!-- Header -->
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="router"></Header>
    <!-- banner -->
    <div class="banner-box"></div>
    <el-row class="videoBackground">
      <el-col style="position: relative;" :span="12">
        <div class="containerVideo">
          <video ref="video" @mouseleave="videoLeave" @mouseenter="entryVideo" muted="muted" style="width: 100%;" :src="topVideoSrc"></video>
          <img @click="playHit(topVideoSrc)" style="cursor: pointer;" src="@/assets/img/documentPage/play.png" />
        </div>
      </el-col>
      <el-col class="rightContent" :span="12">
        <div class="headline">轻骑低代码开发平台</div>
        <div class="content">
          轻骑兵平台是金现代公司数百名开发工程师，历时10余年倾力打造的一款低代码开发平台。平台主要由可视化设计器、工作流服务、基础服务平台组成。通过可视化设计器，可采用拖、拉、拽的方式快速构建复杂业务应用。加速企业数字化转型，让软件开发更简单！
        </div>
        <el-button class="button" @click="openForm">预约体验</el-button>
      </el-col>
    </el-row>
    <div class="productVideo">
      <p>产品视频</p>
      <el-row style="margin-top: 20px">
        <el-col :span="8" v-for="item in videoList" :key="item.id">
          <div class="videoItem" @click="playHit(item.path)">
            <video muted="muted" style="width: 100%;" :src= "item.path" :poster="poster(item.id)"></video>
            <img style="cursor: pointer;" src="@/assets/img/documentPage/play.png" />
            <div class="videoName">{{item.name}}</div>
          </div>
        </el-col>
      </el-row>
      <el-button v-show="videoList.length <= 9" class="experience" @click="openForm">预约体验</el-button>
      <el-button v-show="videoList.length > 9" class="showAll">展开全部</el-button>
    </div>
    <div class="productFile">
      <p>产品文档</p>
      <el-row style="margin-top: 20px">
        <el-col :span="8" v-for="item in productFileList" :key="item.id">
          <div class="fileItem" @click="openFileForm">
            <div v-if="item.type === 'pdf'" class="fileItem_pdf">
              <div class="line"></div>
              <div class="fileInfo fileName">{{item.name}}</div>
              <div class="fileInfo fileTitle">{{item.title}}</div>
            </div>
            <div v-if="item.type === 'word'" class="fileItem_word">
              <div class="line"></div>
              <div class="fileInfo fileName">{{item.name}}</div>
              <div class="fileInfo fileTitle">{{item.title}}</div>
            </div>
            <div v-if="item.type === 'ppt'" class="fileItem_ppt">
              <div class="line"></div>
              <div class="fileInfo fileName">{{item.name}}</div>
              <div class="fileInfo fileTitle">{{item.title}}</div>
            </div>
            <div><img src="@/assets/img/documentPage/download.png" @click="openFileForm"/></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--联系专家-->
    <ContactExperts></ContactExperts>
    <!-- footer -->
    <FhBottom/>
<!--    <Footer></Footer>-->
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 获取文档表单 -->
    <HussarFormForFile v-show="showFileForm" @closeForm="closeFileForm"></HussarFormForFile>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
    <el-dialog class="videoDialog" v-if="videoVisible" :visible.sync="videoVisible" width="56%">
      <video controls style="width: 100%;" ref="videoMagnify" autoplay :src="videoSrc"></video>
    </el-dialog>
  </div>
</template>

<script>
  import Header from './include/Header.vue';
  import Footer from './include/Footer.vue';
  import HussarForm from "./include/HussarForm";
  import ContactExperts from './include/ContactExperts.vue';
  import SideBar from "./include/SideBar";
  import HussarFormForFile from "./include/HussarFormForFile";
  let routerName = "";
  let tagData = "";
  export default {
    name: "DocumentPage",
    data() {
      return {
        router:'/DocumentPage',
        headColor:"dark",
        isPageScroll: false,
        showForm: false,
        showFileForm: false,
        videoVisible: false,
        dangqianUrl: window.location,
        videoList:[
          {id:'1',path: window.location.protocol+ '//'+window.location.hostname+'/video/Hussar_development.mp4',name: '轻骑兵二次开发-前端代码块'},
          {id:'2',path: window.location.protocol+ '//'+window.location.hostname+'/video/Hussar_theme.mp4',name: '轻骑兵主题配置'},
          {id:'3',path: window.location.protocol+ '//'+window.location.hostname+'/video/hussar_ai.mp4',name: '轻骑兵AI低代码开发平台'},
          {id:'4',path: window.location.protocol+ '//'+window.location.hostname+'/video/Hussar_score.mp4',name: '轻骑兵低代码开发平台成绩单'},
          {id:'5',path: window.location.protocol+ '//'+window.location.hostname+'/video/hussar_select.mp4',name: '低代码平台选型指南'},
          {id:'6',path: window.location.protocol+ '//'+window.location.hostname+'/video/hussar_paas.mp4',name: '轻骑兵低代码PaaS平台'},
          {id:'7',path: window.location.protocol+ '//'+window.location.hostname+'/video/hussar_develop.mp4',name: '轻骑兵零代码开发平台'},
        ],
        productFileList:[
          {id:'1',type: 'pdf',path: '',name: '2023中国低代码', title: '/零代码市场发展洞察'},
          {id:'2',type: 'pdf',path: '',name: '2023爱分析·低代码', title: '厂商全景报告'},
          {id:'3',type: 'pdf',path: '',name: '2023信创软件', title: '品牌影响力研究报告'},
          {id:'4',type: 'pdf',path: '',name: '2023年中国低/零代码', title: '行业研究报告'},
          {id:'5',type: 'pdf',path: '',name: '2022低代码·无代码', title: '应用案例汇编'},
          {id:'6',type: 'word',path: '',name: '轻骑兵低代码开发平台', title: '白皮书'},
        ],
        topVideoSrc: window.location.protocol+ '//'+window.location.hostname+'/video/qqbxc.mp4',
        videoSrc: '',
      };
    },
    components: {
      HussarFormForFile,
      Header,
      HussarForm,
      Footer,
      SideBar,
      ContactExperts,
    },
    methods: {
      poster(id) {
        let img = "";
        if (id === '3') {
          img = require("@/assets/img/documentPhonePage/video-ai.png");
          return img;
        }
        return;
      },
      openForm() {
        const self = this;
        self.showForm = true;
      },
      closeForm() {
        const self = this;
        self.showForm = false;
      },
      openFileForm() {
        const self = this;
        self.showFileForm = true;
      },
      closeFileForm() {
        const self = this;
        self.showFileForm = false;
      },
      // 页面滚动
      handleNavScroll() {
        const self = this;
        self.isPageScroll = false;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 80) {
          self.isPageScroll = true;
        }
      },
      // 返回顶部
      backTop() {
        $('html ,body').animate({scrollTop: 0}, 700);
      },
      playHit(src) {
        this.videoSrc = src
        this.videoVisible = true;
      },
      entryVideo() {
        this.$refs.video.play();
      },
      videoLeave() {
        this.$refs.video.pause();
      },
    },
    mounted() {
      const self = this;
      window.addEventListener('scroll', self.handleNavScroll);
      var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet =
        /(?:iPad|PlayBook)/.test(ua) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    var os = {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc,
    };
    if (os.isAndroid || os.isPhone) {
      this.$router.replace({ path: "/DocumentPhonePage" });
    }
    },
    created() {
      if (routerName === "FrontierDetailsArticle" && tagData !== '') {
        this.tag = tagData.name;
        this.tagInfo = tagData
      }
    },
  }
</script>

<style scoped>
  .home {color: #2E2E2E;background: #ffffff}
  .banner-box{width:100%;height:424px;background: url("../assets/img/documentPage/banner-bg.png") no-repeat;margin: 0 auto;background-size: cover;}
  /* 返回顶部 */
  .back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
  .videoBackground {
    display: flex;
    margin: auto;
    margin-top: -272px;
    margin-bottom: 70px;
    height: 301px;
    background: url('~@/assets/img/documentPage/videoBackground.png') no-repeat;
    background-size: 100% 100%;
    width: 1071px;
    padding: 17px;
  }
  .containerVideo {
    display: flex;
    border-radius: 5px;
    left: 3px;
    position: absolute;
    height: 267px;
    width: 476px;
  }
  .containerVideo img {
    right: 0;
    bottom: 0;
    top: 5px;
    left: 0;
    margin: auto;
    position: absolute;
  }
  .rightContent{
    padding-right: 40px
  }
  .rightContent .headline{
    font-size: 30px;
    font-weight: bold;
    color: #2E2E2E;
    margin-top: 37px;
  }
  .rightContent .content{
    font-size: 14px;
    font-weight: 400;
    color: #2E2E2E;
    line-height: 25px;
    margin-top: 16px;
  }
  .rightContent .button{
    color: #186CF5;
    border-color: #186CF5;
    margin-top: 20px;
  }
  video{cursor: pointer}
  .videoDialog /deep/ .el-dialog__header{
    padding: 0;
  }
  .videoDialog /deep/ .el-dialog__body {
    padding: 0;
  }
  .videoDialog /deep/ .el-dialog__header .el-dialog__headerbtn{
    z-index: 9999;
  }
  .productVideo, .productFile{
    text-align: center;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 70px;
  }
  .productVideo p, .productFile p{
    font-size: 34px;
    font-weight: bold;
    color: #2E2E2E;
  }
  .productVideo .videoItem{
    width: 380px;
    height: 288px;
    background: #FFFFFF;
    box-shadow: 0px 0px 15px 1px rgba(3,64,170,0.2);
    border-radius: 0px 0px 0px 0px;
    margin: 20px auto;
    position: relative;
    cursor: pointer;
  }
  .productVideo .videoItem:hover {
    transform: translate(0,-10px);transition: all 500ms ease;
  }
  .videoItem img {
    width: 33px;
    height: 33px;
    position: absolute;
    left: 15px;
    top: 14px;
  }
  .videoItem .videoName{
    font-size: 18px;
    font-weight: 400;
    color: #2E2E2E;
    text-align: left;
    margin-top: 22px;
    padding-left: 18px;
  }
  .experience{
    background-color: #186CF5;
    border: #186CF5;
    color: #ffffff;
    height: 38px;
    width: 110px;
    margin-top: 40px;
  }
  .experience:hover{
    background-color: #1584F3;
    border-color: #1584F3;
  }
  .showAll{
    width: 140px;
    height: 36px;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #D2D2D2;
    color: #919191;
    margin-top: 40px;
  }
  .showAll:hover{
    border-color: #186CF5;
    color: #186CF5;
    background: #fff;
  }
  .fileItem{
    width: 380px;
    height: 208px;
    background: #FFFFFF;
    box-shadow: 0 0 15px 1px rgba(3,64,170,0.1);
    border-radius: 5px 5px 5px 5px;
    margin: 20px auto;
  }
  .productFile .fileItem:hover {
    transform: translate(0,-10px);
    transition: all 500ms ease;
    cursor: pointer;
  }
  .fileItem_pdf{
    background: url('~@/assets/img/documentPage/pdf-bg.png');
    width: 380px;
    height: 152px;
  }
  .fileItem_word{
    background: url('~@/assets/img/documentPage/word-bg.png');
    width: 380px;
    height: 152px;
  }
  .fileItem_ppt{
    background: url('~@/assets/img/documentPage/ppt-bg.png');
    width: 380px;
    height: 152px;
  }
  .line{
    width: 36px;
    height: 3px;
    border-radius: 20px;
    margin-top: 39px;
    margin-left: 26px;
    position: absolute;
  }
  .fileItem_pdf .line{
    background: #FF6B6B;
  }
  .fileItem_word .line{
    background: #2A8FF5;
  }
  .fileItem_ppt .line{
    background: #F88448;
  }
  .fileInfo{
    font-size: 20px;
    font-weight: bold;
    color: #2E2E2E;
    line-height: 32px;
    text-align: left;
    position: absolute;
    max-width: 200px;
    margin-left: 26px;
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    /*display: -webkit-box;*/
    /*-webkit-line-clamp: 2;*/
    /*-webkit-box-orient: vertical;*/
  }
  .fileName{
    margin-top: 61px;
  }
  .fileTitle{
    margin-top: 93px;
  }
  .fileItem img{
    margin-top: 16px;
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/DocumentPage.vue